export default {
  banner_v2: {
    title: '<span class={title}>Obtenez <span class={highlight}>$100</span> et plus pendant la Saison des Récompenses DSers</span>',
    desc: `La Saison des Récompenses DSers aura lieu du 15 Octobre au 15 Janvier. <br />
      Des invitations seront envoyées à des marchands aléatoire en Septembre.<br />
      Vérifier votre email pendant cette période.`,
    learn_more: 'En savoir plus'
  }
};
